var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2333 11.2639L15.5503 15.5M6.80288 3.38318C8.39667 3.38318 9.6887 4.67402 9.6887 6.26636M13.1196 6.77892C13.1196 10.2467 10.3059 13.0578 6.83495 13.0578C3.36403 13.0578 0.550293 10.2467 0.550293 6.77892C0.550293 3.31117 3.36403 0.5 6.83495 0.5C10.3059 0.5 13.1196 3.31117 13.1196 6.77892Z",
    stroke: "#7C7C7C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c2f7ab17b4756a5723cb47f66082399e.svg";
export { ForwardRef as ReactComponent };